export const DUPLICATE_SITE_MODAL_HEADER = "Duplicate Site";

export const CENTER = "center";
export const DISABLE_ROW = "disabled-row";
export const DEFAULT_MODAL_WIDTH = "75%";
export const EMAIL_MODAL_HEADER = "Send Email";
export const EMAIL_MODAL_WIDTH = "40%";
export const SEND_SMS_MODAL_HEADER = "Send Message";
export const MESSAGE_SITE_MODAL_HEADER = "SMS Site";
export const LOCATION_MODAL_HEADER = "Site Location";
export const LOCATION_MODAL_WIDTH = "90%";

export const SITE_TABLE_LABELS = Object.freeze({
  CLIENT: "Client",
  CLIENT_KEY: "Client",
  SITE: "Site",
  SITE_KEY: "Name",
  DEFAULT_SHIFT_TYPE: "Default Booking Type",
  DEFAULT_SHIFT_TYPE_KEY: "DefaultShiftTypeName",
  TAGS: "Tags",
  TAGS_KEY: "Tags",
  BRANCHES: "Branches",
  BRANCHES_KEY: "Branches",
  STATUS: "Status",
  STATUS_KEY: "Status",
  EMAIL: "Send Email",
  PHONE: "Call",
  LOCATION: "Location",
  ROW_KEY: "ObjectId",
  MPTY: ""
});

export const SITE_FILTER_LABELS = Object.freeze({
  ADD_SITE_BTN: "Add Site",
  CLIENT_FILTER_PLACEHOLDER: "Client",
  STATUS_FILTER_PLACEHOLDER: "Status",
  BRANCH_FILTER_PLACEHOLDER: "Branch",
  TAGS_FILTER_PLACEHOLDER: "Tags",
  PROCESSED: "Processed",
  DONOTUSE: "DoNotUse",
  INACTIVE: "Inactive",
  ACTIVE: "Active",
  UNPROCESSED: "Unprocessed"
});

// Duplicated subset of CANDIDATE_FILTER (owned by the upcoming candidate-management step),
// used only for the default select value on site-activity filters.
export const CANDIDATE_FILTER_LABELS = Object.freeze({
  ACTIVE: "Active"
});

// Duplicated subset of CLIENT_MANAGEMENT (owned by the upcoming client-management step),
// used only for the "Add Client" modal opened from the site profile page.
export const CLIENT_MANAGEMENT_LABELS = Object.freeze({
  ADD_CLIENT_BTN: "Add New Client",
  ADD_CLIENT_MODAL: "Add Client",
  CLIENT_MODAL_WIDTH: "40%"
});
